import { useEffect, useRef, useState } from 'react';
import { getApiToken } from '../../utilityFunctions/getApiToken';
import { getHeadersAuthorization } from '../../utilityFunctions/apiheadersauthorization';

const LandingElabs = () => {
    const [elaborations, setElaborations] = useState([]);
    const [expanded, setExpanded] = useState({});

    const scrollRef = useRef(null);
    const intervalRef = useRef(null);
    const userInteracting = useRef(false);
    const timeoutRef = useRef(null);
    const scrollDirection = useRef('forward');

    useEffect(() => {
        const fetchElaborations = async () => {
            let token = await getApiToken();
            const url = process.env.REACT_APP_API_HOST + "elaborations/getall/207";
            const response = await fetch(url, {
                method: 'POST',
                headers: getHeadersAuthorization(token)
            }).then(res => res);
            const data = await response.json();
            const shuffled = data.items.sort(() => 0.5 - Math.random());
            setElaborations(shuffled.slice(0, 3));
        };

        fetchElaborations();
    }, []);

    const toggleExpand = (idx) => {
        setExpanded((prev) => ({ ...prev, [idx]: !prev[idx] }));
    };

    const startScroll = () => {
        const el = scrollRef.current;
        if (!el) return;

        intervalRef.current = setInterval(() => {
            if (userInteracting.current) return;

            const maxScroll = el.scrollWidth - el.clientWidth;
            const minScroll = 0;

            if (scrollDirection.current === 'forward') {
                if (el.scrollLeft >= maxScroll) {
                    scrollDirection.current = 'backward';
                } else {
                    el.scrollBy({ left: 1, behavior: 'smooth' });
                }
            } else if (scrollDirection.current === 'backward') {
                if (el.scrollLeft <= minScroll) {
                    scrollDirection.current = 'forward';
                } else {
                    el.scrollBy({ left: -1, behavior: 'smooth' });
                }
            }
        }, 50);
    };

    useEffect(() => {
        const el = scrollRef.current;
        if (!el) return;

        startScroll();

        const onUserInteract = () => {
            userInteracting.current = true;
            clearInterval(intervalRef.current);
            clearTimeout(timeoutRef.current);

            timeoutRef.current = setTimeout(() => {
                userInteracting.current = false;
                startScroll();
            }, 3000);
        };

        el.addEventListener('touchstart', onUserInteract);
        el.addEventListener('mousedown', onUserInteract);
        el.addEventListener('wheel', onUserInteract);

        return () => {
            clearInterval(intervalRef.current);
            clearTimeout(timeoutRef.current);
            el.removeEventListener('touchstart', onUserInteract);
            el.removeEventListener('mousedown', onUserInteract);
            el.removeEventListener('wheel', onUserInteract);
        };
    }, []);

    // Funzione per troncare testo
    const truncateText = (text, limit) => {
        if (text.length <= limit) return text;
        return text.substring(0, limit) + '...';
    };

    return (
        <div className="container my-4">
            <h2 className='landing-section-heading'>Ultime elaborazioni degli utenti</h2>
            {/* Mobile */}
            <div
                className="d-flex d-md-none flex-nowrap overflow-auto align-items-start pb-3 elabs-scroll"
                style={{ gap: '1rem' }}
                ref={scrollRef}
            >
                {elaborations.map((elab, idx) => (
                    <div key={idx} className="sport-card" style={{ maxWidth: '280px', flex: '0 0 auto' }}>
                        <img
                            src={'https://res.cloudinary.com/racemood/image/upload/' + JSON.parse(elab.img)[0]}
                            className="card-img-top"
                            alt={`Elaborazione ${idx}`}
                            style={{ objectFit: 'cover', height: '250px', width: '100%' }}
                        />
                        <div className="p-2 text-center">
                            <h5 className="mb-2" style={{ fontSize: '1.1rem' }}>{elab.title}</h5>
                            <div className="accent-divider mx-auto my-2"></div>
                            <p className="description-text mb-0" style={{ fontSize: '0.95rem' }}>
                                {expanded[idx]
                                    ? elab.description
                                    : truncateText(elab.description, 300)}
                            </p>
                            {elab.description.length > 300 && (
                                <button
                                    onClick={() => toggleExpand(idx)}
                                    className="other-btn">
                                    {expanded[idx] ? 'Chiudi' : 'Altro'}
                                </button>
                            )}
                        </div>
                    </div>
                ))}
            </div>

            {/* Desktop */}
            <div className="row d-none d-md-flex">
                {elaborations.map((elab, idx) => (
                    <div key={idx} className="col-md-4 mb-3">
                        <div className="sport-card" style={{ width: '100%' }}>
                            <img
                                src={'https://res.cloudinary.com/racemood/image/upload/' + JSON.parse(elab.img)[0]}
                                className="card-img-top"
                                alt={`Elaborazione ${idx}`}
                                style={{ objectFit: 'cover', height: '250px', width: '100%' }}
                            />
                            <div className="p-2 text-center">
                                <h5 className="mb-2" style={{ fontSize: '1.1rem' }}>{elab.title}</h5>
                                <div className="accent-divider mx-auto my-2"></div>
                                <p className="description-text mb-0" style={{ fontSize: '0.95rem' }}>{elab.description}</p>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default LandingElabs;